import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema2 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema2_Primeros_Conceptos.pdf`;
  /*const pdfUrl = "/pdf/Tema2_Primeros_Conceptos.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 2: Primeros Conceptos</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 2: Primeros Conceptos" />
      </Container>
    </>
  );
};

 export default PythonTema2;
